"use strict";
// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../../../../node_modules/webpack/module.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=index.js.map